import { useState } from "react";
import { Plane } from "lucide-react";
import { logoUrl, when } from "@/lib/flights";

const Logo = ({ code }) => {
  const [ok, setOk] = useState(true);
  if (!code || !ok) return <span className="grid h-9 w-14 shrink-0 place-items-center rounded-md bg-slate-100 text-slate-400"><Plane size={16} /></span>;
  return <img src={logoUrl(code)} alt="" onError={() => setOk(false)} className="h-9 w-14 shrink-0 object-contain" />;
};

const T = {
  es: { head: "Vuelos incluidos", outbound: "Vuelo de ida", inbound: "Vuelo de regreso", conn: "Conexión", dep: "Sale", arr: "Llega" },
  en: { head: "Included flights", outbound: "Outbound flight", inbound: "Return flight", conn: "Connection", dep: "Departs", arr: "Arrives" },
};

export const FlightsBox = ({ flights, lang = "es", accent = "#2F5BFF", testid = "pay-flights" }) => {
  if (!flights || !Object.values(flights).some((s) => s?.length)) return null;
  const t = T[lang === "en" ? "en" : "es"];
  const en = lang === "en";
  return (
    <div className="px-7 pb-6 sm:px-9" data-testid={testid}>
      <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em]" style={{ color: accent }}>{t.head}</p>
      <div className="space-y-3">
        {["outbound", "inbound"].flatMap((leg) => (flights[leg] || []).map((s, i) => (
          <div key={`${leg}-${i}`} className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white/70 p-3" data-testid={`${testid}-${leg}-${i}`}>
            <Logo code={s.has_logo === false ? null : s.airline} />
            <div className="min-w-0 text-sm">
              <p className="text-xs text-slate-500">{i === 0 ? t[leg] : `${t[leg]} · ${t.conn} ${i}`}</p>
              <p className="font-semibold text-slate-800">{[s.airline_name || s.airline, s.flight_no].filter(Boolean).join(" · ")}</p>
              <p className="text-slate-700">{s.from_label || s.from_code} → {s.to_label || s.to_code}</p>
              <p className="text-xs text-slate-500">
                {[s.dep || when(s.dep_date, s.dep_time, en), s.arr || when(s.arr_date, s.arr_time, en)].map((v, k) => (v ? `${k ? t.arr : t.dep} ${v}` : null)).filter(Boolean).join(" · ")}
              </p>
            </div>
          </div>
        )))}
      </div>
    </div>
  );
};
